import './PickUpPoints.css';

function PickUpPoints() {
    return (
        <h3 className='oops'>Oops! this service is not available yet, please check back soon, thanks!</h3>
    )
}

export default PickUpPoints;